/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GoodIlsReportDto } from '../../models/good-ils-report-dto';
import { RegenerateGoodIlsReportDto } from '../../models/regenerate-good-ils-report-dto';

export interface GoodIlsControllerRegenerate$Params {
      body: RegenerateGoodIlsReportDto
}

export function goodIlsControllerRegenerate(http: HttpClient, rootUrl: string, params: GoodIlsControllerRegenerate$Params, context?: HttpContext): Observable<StrictHttpResponse<GoodIlsReportDto>> {
  const rb = new RequestBuilder(rootUrl, goodIlsControllerRegenerate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GoodIlsReportDto>;
    })
  );
}

goodIlsControllerRegenerate.PATH = '/good-ils/regenerate';
